var exports = {
  "k": "CloneAllowedToggle.module__container___dWJKQm",
  "f": "CloneAllowedToggle.module__permissionHint___dWJKQm",
};

module.exports = exports;
